import React, { useState, memo, useEffect } from 'react'
import classNames from 'classnames'
import parse from 'html-react-parser'
import Icon from 'root/src/client/web/base/Icon'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import withStyles from '@material-ui/core/styles/withStyles'
import {
	colorsNew,
	boxShadow,
	ltGtMediaQuery,
} from 'root/src/client/web/commonStyles'

const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		boxShadow: boxShadow(colorsNew.primary),
		border: [[3, 'solid', '#FFF']],
		borderRadius: 4,
		overflow: 'hidden',
		margin: [[10, 0]],
		width: '100%',
		[ltGtMediaQuery]: {
			width: '90%',
		},
	},
	header: {
		display: 'flex',
		cursor: 'pointer',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: 81,
		userSelect: 'none',
		[ltGtMediaQuery]: {
			minHeight: 81,
			height: 'auto',
		},
	},
	headerElement: {
		margin: [[15, 20]],
	},
	content: {
		transition: '0.3s max-height ease',
		'& > *': {
			margin: [[0, 20, 20, 20]],
		},
	},
	expanded: {
		maxHeight: 500,
	},
	collapsed: {
		maxHeight: 0,
	},
}

const Accordion = memo(({ id, isActive = false, classes, title, content }) => {
	const [expanded, setExpanded] = useState(false)
	useEffect(() => {
		setExpanded(isActive)
	}, [isActive])
	const toggleExpand = () => setExpanded(prev => !prev)

	return (
		<div className={classes.root} id={id}>
			<div
				onClick={toggleExpand}
				className={classes.header}
			>
				<div className={classes.headerElement}>
					<Typography
						variant={typographyVariants.smallBold}
					>
						{title}
					</Typography>
				</div>
				<div className={classes.headerElement}>
					<Icon
						icon={expanded ? faMinus : faPlus}
						glow={colorsNew.primary}
						color={colorsNew.light1}
					/>
				</div>
			</div>
			<div
				className={classNames(
					classes.content,
					expanded ? classes.expanded : classes.collapsed,
				)}
			>
				<Typography
					variant={typographyVariants.small}
				>
					{parse(content)}
				</Typography>
			</div>
		</div>
	)
})

export default withStyles(styles, { name: 'MuiAccordion' })(Accordion)
